import React from 'react'
import { Button } from '@mui/material'


const SecondaryButton = ({children, width, color, onClick, disabled, height,border}) => {
  return (
    <Button 
      size='small' 
      disabled={disabled} 
      variant="outlined" 
      sx={{
        // backgroundColor: '#E598AC',
        fontSize: {
          xs: '10px',
          md: '14px'
        },
        height: height,
        width: width,
        color: color,
        borderRadius: '78px',
        border:border,
        fontWeight:'bold',
        '&:hover': {
          // backgroundColor: '#E598AC' 
        }
      }} 
      onClick={onClick}
    >
      {children}
    </Button>
  )
} 

export default SecondaryButton;
